import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AppBody from "../../components/AppBody";
import {
  trainingCourseList,
  getAllTrainingCourseList,
  deleteTrainingCourse,
} from "../../../actions/admin/certification/training_course_action";
import ViewTrainingCourseModel from "./ViewTrainingCourseModel";
import { ToastContainer, toast } from "react-toastify";
const TrainingCourseList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state.trainingCourseReducer);
  const moduleState = useSelector((state) => state.trainingModuleReducer);
  const topicState = useSelector((state) => state.trainingTopicReducer);
  //const []
  useEffect(() => {
    dispatch(getAllTrainingCourseList());
  }, []);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);

  const viewData = (d) => {
    setData(d);
    setShow(true);
  };

  const handelResetPopup = () => {
    setData([]);
    setShow(false);
  };

  const deleteCourse = (id) => {
    dispatch(deleteTrainingCourse({ course_id: id }));
  };
  if (state.is_done) {
    toast("Course Deleted Successfully!", {
      type: "danger",
      position: "top-center",
    });
    dispatch(getAllTrainingCourseList());
  }

  const redirectEdit = () => {
    navigate("/admin/create-training-course");
  };

  return (
    <AppBody
      loading={state.loading || moduleState.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
            <div className="card-body p-3 w-100 bg-current border-0 d-flex rounded-lg">
              <Link to={"/admin/home"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Training Course List
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/admin/create-training-course"}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Create Training Course"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>{" "}
              <br />
            </div>
            <ToastContainer />
            <div className="card-body p-0 w-100 border-0 ">
              <div className="table-responsive">
                {state.errors && state.errors.other_error && (
                  <div class="alert alert-danger">
                    <strong>Danger!</strong> {state.errors.other_error}
                  </div>
                )}
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Price</th>
                      <th>Duration</th>
                      <th>Level</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((obj, i) => (
                        <tr>
                          <td>{i + 1}</td>
                          <td>{obj.name}</td>
                          <td>{obj.price}</td>
                          <td>{obj.duration + " " + obj.duration_type}</td>
                          <td>{obj.level}</td>
                          <td>
                            <input
                              type="button"
                              value="Add"
                              onClick={() => redirectEdit()}
                              className="btn approve_btn btn-common"
                            />
                            <input
                              type="button"
                              value="View"
                              onClick={() => viewData(obj.modules)}
                              className="btn approve_btn btn-common"
                            />
                            <input
                              type="button"
                              value="Delete"
                              className="btn approve_btn btn-common"
                              onClick={() => deleteCourse(obj.id)}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {show && (
            <ViewTrainingCourseModel
              show={show}
              data={data}
              handelClosePopup={() => handelResetPopup()}
            />
          )}
        </div>
      }
    />
  );
};

export default TrainingCourseList;
